import request from '@/utils/request'

/* member player */
export function addPlayer(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddPlayer.json',
    method: 'post',
    data
  })
}

export function updatePlayer(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdatePlayer.json',
    method: 'post',
    data
  })
}

export function deletePlayer(id) {
  const data = {
    userId: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeletePlayer.json',
    method: 'post',
    data
  })
}

export function getPlayerById(id) {
  const params = {
    id: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetPlayer.json',
    method: 'get',
    params
  })
}

export function getPlayerList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetPlayerList.json',
    method: 'post',
    params
  })
}

// 监护人jsonarray[{id,name,mobile,email,address,work,relation},..]
export function updatePlayerGuardian(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdatePlayerGuardian.json',
    method: 'post',
    data
  })
}

export function GetPlayersYearsList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayersYearsList.json',
    method: 'get',
    params
  })
}
export function GetPlayerYearsList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerYearsList.json',
    method: 'get',
    params
  })
}
export function GetPlayerGamesDataList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerGamesDataList.json',
    method: 'get',
    params
  })
}
export function GetPlayerMatchesDataList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerMatchesDataList.json',
    method: 'get',
    params
  })
}
export function GetPlayerTeamsDataList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerTeamsDataList.json',
    method: 'get',
    params
  })
}
